import type {CustomFieldsFilterConfig} from "@/frontendClasses/CustomFieldsFilterConfig";
import type {EquipmentFilterConfig} from "@/frontendClasses/EquipmentFilterConfig";
import type {SearchFilterConfig} from "@/frontendClasses/SearchFilterConfig";

export interface StandardFilterConfig {
    /**
     * Lista wyposażeń, które muszą być spełnione łącznie
     * Wewnątrz może być podtablica z listą w której wystarczy że jedno z wyposażeń jest dostępne
     */
    equipmentFilters?: (string|EquipmentFilterConfig|(string|EquipmentFilterConfig)[])[];
    tags?: string[];
    customFieldFilters?: (string|CustomFieldsFilterConfig)[];
    location?: {
        city?: string,
        street?: string,
        name?: string
    };
    roomStandardIds: number[];
    onlyFavorites: boolean;
    favoriteRoomStandardIds: number[];
    /**
     * Filtr na cenę minimalną, inkluzywnie
     */
    priceMinimum?: number;
    /**
     * Filtr na cenę maksymalną, inkluzywnie
     */
    priceMaximum?: number;
    search: SearchFilterConfig[];
}

export const initialStandardFilterConfig: StandardFilterConfig = {
    favoriteRoomStandardIds: [],
    customFieldFilters: [],
    tags: [],
    onlyFavorites: false,
    equipmentFilters: [],
    location: {
        city: undefined,
        street: undefined,
        name: undefined
    },
    roomStandardIds: [],
    priceMinimum: undefined,
    priceMaximum: undefined,
    search: []
}
